import { surveyAnalyticsService } from '../../services/SurveyAnalytics.service'
import { Array } from 'core-js';

const state = {
    chartDataApi: Array,
    tableDataApi: Array,
    chartData: Array,
    tableData: [],
    headerData: [],
    dataCountInfo: [],
    modelScoreRadios: 'scaledMeanScore',
}

// getters
const getters = {}

function getInputCategories(filterArray, inputCategories) {
    filterArray.map((filter) => {
        inputCategories = inputCategories.concat(
            filter.keyValues.map((keyval) => {
                return keyval.itemValue;
            })
        );
    })
    return inputCategories;
}

// actions
const actions = {
    getChartData({ commit }) {
        surveyAnalyticsService.getChartData(chartData => {
            commit('setChartAndTableData', chartData)
        })
    },
    updateChart({ commit }, scoreView) {
        commit('setChartDataAsPerScoreView', { scoreView: scoreView });
    },
    getTableDataBOB({ commit }) {
        commit('setTableDataBOB');
    },
    getChartDataBOB({ commit, rootState }) {
       // dispatch('UserManagementStore/getUserClientDetails', null, { root: true });
        //.then(() => {
            let inputCategories = [];
            inputCategories = getInputCategories(rootState.CategoriesStore.tblYourDataFilters, inputCategories);
            inputCategories = getInputCategories(rootState.CategoriesStore.tblBenchmarkFilters, inputCategories);

            let clientId = rootState.UserManagementStore.UserClientId;
            inputCategories.push("ClientID-" + clientId);
            const filters = {
                SampleTypeId: rootState.AppStore.ProductLine.payload,
                Filters: {
                    SelectedOptions: inputCategories
                }
            }

            if (rootState.CategoriesStore.tblBenchmarkFilters.length > 0) {
                return new Promise((resolve, reject) => {
                    surveyAnalyticsService.getClientDataWithBenchmarkFilter(
                        filters,
                        apiData => {
                            commit('setChartAndTableData', { apiData: apiData }),
                                resolve()
                        },
                        err => {
                            reject(err)
                        })
                })
            }
            else {
                return new Promise((resolve, reject) => {
                    surveyAnalyticsService.getClientDataWithBenchmark(
                        filters,
                        apiData => {
                            commit('setChartAndTableData', { apiData: apiData }),
                                resolve()
                        },
                        err => {
                            reject(err)
                        })
                })
            }
      //  })
    },
}

function getScoreArrayForChart(lables, inputScoreArray) {
    let outputScoreArray = [];
    let innerArray = [];
    inputScoreArray.map((score) => {
        innerArray = [];
        lables.map((label) => {
            var valobj = score.data.find((data) => {
                return label.code == data.code;
            })
            if (valobj) {
                innerArray.push(valobj.value);
            }
        })
        outputScoreArray.push(
            {
                displayName: score.displayName,
                values: innerArray
            }
        )
    })
    return outputScoreArray;
}

function AddSigTestingArrow(trend) {
    let result = "";
    switch (trend) {
        case "4": {
            result = '<i class=material-icons style=\\"color: green;\\">arrow_drop_up</i>';
            break;
        }
        case "3": {
            result = '<i class=material-icons style=\\"color: red;\\">arrow_drop_down</i>';
            break;
        }
        default: {
            result = "";
        }
    }
    return result;
}

function getScoreArrayForTable(lables, inputScoreArray) {
    //console.log(JSON.stringify(inputScoreArray));
    let tableDataSMSScoreArray = "";
    inputScoreArray.map((score) => {
        let isBenchmark = false;
        if (score.displayName == "Benchmark") {
            isBenchmark = true;
           tableDataSMSScoreArray = tableDataSMSScoreArray + '{"displayName":"<strong>' + score.displayName + '</strong>",';
           // tableDataSMSScoreArray = tableDataSMSScoreArray + '{"displayName":"' + score.displayName + '",';
        }
        else {
            tableDataSMSScoreArray = tableDataSMSScoreArray + '{"displayName":"' + score.displayName + '",';
        }
        lables.map((label) => {
            var valobj = score.data.find((data) => {
                return label.code == data.code;
            })

            if (valobj) {
                let arrowBenchmark = AddSigTestingArrow(valobj.trend);
                if (isBenchmark) {
                    tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '"'
                        + ':' + '"' + arrowBenchmark + '<strong>' + valobj.value + '</strong>",';
                       // + ':' + '"' + arrowBenchmark +  valobj.value + '",';
                      //  + ':' + '"' + valobj.value + '",';

                    //tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '_trend' + '"'
                    //    //+ ':' + '"' + arrowBenchmark + '<strong>' + valobj.value + '</strong>",';
                    //    // + ':' + '"' + arrowBenchmark +  valobj.value + '",';
                    //    + ':' + '"' + valobj.trend + '",';
                }
                else {
                    tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '"'
                        + ':' + '"' + arrowBenchmark + valobj.value + '",';
                      //  + ':' + '"' + valobj.value + '",';

                    //tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '_trend' + '"'
                    //    //+ ':' + '"' + arrowBenchmark + '<strong>' + valobj.value + '</strong>",';
                    //    // + ':' + '"' + arrowBenchmark +  valobj.value + '",';
                    //    + ':' + '"' + valobj.trend + '",';
                }
            }
            //innerArray.push(valobj.value);
        })
        let lastcomma = tableDataSMSScoreArray.lastIndexOf(',');
        tableDataSMSScoreArray = tableDataSMSScoreArray.substring(0, lastcomma);
        tableDataSMSScoreArray = tableDataSMSScoreArray + '},';
    })
    let lastcommaTableData = tableDataSMSScoreArray.lastIndexOf(',');
    tableDataSMSScoreArray = tableDataSMSScoreArray.substring(0, lastcommaTableData);
    tableDataSMSScoreArray = JSON.parse('[' + tableDataSMSScoreArray + ']');

    //console.log(JSON.stringify(tableDataSMSScoreArray));
    return tableDataSMSScoreArray;
}

function getTableHeadersAndChartLabels(lables) {
    let chartCategories = [];
    let tableHeaders = [];
    tableHeaders.push(
        {
            text: "Data Points",
            value: "displayName",
            displayName_trend: ""
        }
    );
    for (let k = 0; k < lables.length; k++) {
        let label = lables[k];

        tableHeaders.push(
            {
                text: label.value,
                value: label.code,
                [label.code+"_trend"]: "0"
            }
        );

        if (label.value.trim().indexOf(' ') >= 0) {
            const words = label.value.split(" ");
            let aux = []
            let concat = []
            for (let l = 0; l < words.length; l++) {
                concat.push(words[l])
                let join = concat.join(' ')
                aux.push(join);
                concat = []
            }
            if (concat.length) {
                aux.push(concat.join(' ').trim())
            }
            chartCategories.push(aux);
        }
        else {
            chartCategories.push(label.value);
        }
    }
    return {
        tableHeaders: tableHeaders,
        chartCategories: chartCategories
    }
}

function SetChartDataSets(chartData) {
    let chartDataSets = [];
    let colors = ['#203E57', '#203E57', '#0072AD', '#53c68c', '#ffb3ff', '#005582',
        '#4dc1ff', '#00e673', '#8585e0', '#aa80ff', '#ffb3ff'];
    let bobColor = '#8C9396';

    for (let n = 0; n < chartData.length; n++) {
        let srs = chartData[n];
        let chartType = 'bar';
        let anchor = 'end';
        let datalabelcolor = '#ffffff';
        let align = 'start';
        let barColor = colors[n];

        if (srs.displayName == 'Benchmark') {
            anchor = 'end',
                align = 'start',
                //                datalabelcolor = '#000000',
                barColor = bobColor
        }
        let datalabels = {
            color: datalabelcolor,
            anchor: anchor,
            align: align,
            //color: '#005582',
            //offset: 15,
            rotation: 270,
            //display: 'auto',
            formatter: function (value) {
                if (value == 0) return "";
                else return value;
                //else return value + '%';
            },
            font: {
                weight: 'bold',
                size: 11,
            }
        }

        let barThickness = Math.round(1.9 * (window.innerHeight) / 100);

        let chartdb = {
            label: srs.displayName,
            data: srs.values,
            //legend: {
            //    display: false,
            //    usePointStyle: true
            //},
            type: chartType,
            showLine: false,
            backgroundColor: barColor,
            fill: 'false',
            //borderColor: '#005582',
            //borderWidth: '1',
            datalabels: datalabels,
            barPercentage: 0.2,
            barThickness: barThickness,
        }
        chartDataSets.push(chartdb);
    }
    return chartDataSets;
}


// mutations
const mutations = {
    setChartAndTableData(state, { apiData }) {
        //console.log(JSON.stringify(apiData));
        let dataCountInfo = apiData.summaryData;
        let chartData = apiData.chartData;
        let tableData = apiData.tableData;
        //Get table headers and chart x-axis labels.
        let resultHeaders = getTableHeadersAndChartLabels(chartData.lables);
        let tableHeaders = resultHeaders.tableHeaders;
        let chartCategories = resultHeaders.chartCategories;
        //Get Scaled Mean Score data for chart and data table.
        let smsScoreArray = getScoreArrayForChart(chartData.lables, chartData.scaledMeanScore);
        let tableDataSMSScoreArray = getScoreArrayForTable(chartData.lables, tableData.scaledMeanScore);
        //Get Summary Rate Score data for chart and data table.
        let srScoreArray = getScoreArrayForChart(chartData.lables, chartData.summaryRate);
        let tableDataSRScoreArray = getScoreArrayForTable(chartData.lables, tableData.summaryRate);
        //Get Top Box Rate Score data for chart and data table.
        let tpScoreArray = getScoreArrayForChart(chartData.lables, chartData.topBoxRate);
        let tableDataTPScoreArray = getScoreArrayForTable(chartData.lables, tableData.topBoxRate);

        let chartDataSets = [];
        let dataForTable = [];
        if (state.modelScoreRadios == 'scaledMeanScore') {
            chartDataSets = SetChartDataSets(smsScoreArray);
            dataForTable = tableDataSMSScoreArray;
        }
        else if (state.modelScoreRadios == 'summaryRateScore') {
            chartDataSets = SetChartDataSets(srScoreArray);
            dataForTable = tableDataSRScoreArray;
        }
        else if (state.modelScoreRadios == 'topBoxScore') {
            chartDataSets = SetChartDataSets(tpScoreArray);
            dataForTable = tableDataTPScoreArray;
        }

        let updatedChartData = {
            datasets: chartDataSets,
            labels: chartCategories
        };

        state.chartDataApi = {
            labels: chartCategories,
            smsScoreArray: smsScoreArray,
            srScoreArray: srScoreArray,
            tpScoreArray: tpScoreArray
        };

        state.tableDataApi = {
            headers: tableHeaders,
            tableDataSMSScoreArray: tableDataSMSScoreArray,
            tableDataSRScoreArray: tableDataSRScoreArray,
            tableDataTPScoreArray: tableDataTPScoreArray,
        };
        //Set Chart Data
        state.chartData = updatedChartData
        //Set Table Headers
        state.headerData = tableHeaders;
        //Set Table Data
        state.tableData = dataForTable;
        //Set data count info
        state.dataCountInfo = dataCountInfo;
    },

    setChartDataAsPerScoreView(state, { scoreView }) {
        let chartData = state.chartDataApi;
        let tableData = state.tableDataApi;

        let smsScoreArray = chartData.smsScoreArray;
        let srScoreArray = chartData.srScoreArray;
        let tpScoreArray = chartData.tpScoreArray;

        let chartDataSets = [];
        let dataForTable = [];
        if (scoreView == 'scaledMeanScore') {
            chartDataSets = SetChartDataSets(smsScoreArray);
            dataForTable = tableData.tableDataSMSScoreArray;
        }
        else if (scoreView == 'summaryRateScore') {
            chartDataSets = SetChartDataSets(srScoreArray);
            dataForTable = tableData.tableDataSRScoreArray;
        }
        else if (scoreView == 'topBoxScore') {
            chartDataSets = SetChartDataSets(tpScoreArray);
            dataForTable = tableData.tableDataTPScoreArray;
        }
        let updatedChartData = {
            datasets: chartDataSets,
            labels: chartData.labels
        };
        //Set Chart Data
        state.chartData = updatedChartData
        //Set Table Data
        state.tableData = dataForTable;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}